import React, { useState } from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import ServiceImg from "../../assets/images/about-img.jpg";
import { Link } from "react-router-dom";
import { Pagination } from "react-bootstrap";
import BlogImg1 from "../../assets/images/blogs/blog-1.jpg";
import BlogImg2 from "../../assets/images/blogs/blog-2.jpg";
import BlogImg3 from "../../assets/images/blogs/blog-3.jpg";
import BlogImg4 from "../../assets/images/blogs/blog-4.jpg";
import BlogImg5 from "../../assets/images/blogs/blog-5.jpg";

export const BlogSec = () => {
  const blogsPerPage = 6; // Number of blogs to show per page
  const [activePage, setActivePage] = useState(1);

  const blogs = [
    {
      id: 1,
      img: BlogImg1,
      date: "Jan 08 2025",
      title:
        "Building the Future: How Our Mobile App Development Company Turns Ideas into Reality",
      content:
        "In today’s fast-paced digital world, mobile applications have become an essential tool for businesses to connect with their customers, streamline operations, and stay ahead of the competition. At CodeInfoWay, we are passionate about bringing innovative ideas to life through our expertise in mobile app development, with a special focus on the React Native platform.",
    },
    {
      id: 2,
      img: BlogImg2,
      date: "Jan 08 2025",
      title: "Why React Native Is the Perfect Choice for Your Next Mobile App",
      content:
        "In the ever-evolving world of mobile app development, businesses face a crucial decision: which platform and technology will best meet their needs? At CodeInfoWay, we have found React Native to be the perfect solution for creating dynamic, high-performing, and cost-effective mobile applications. Here’s why React Native might be the ideal choice for your next app.",
    },
    {
      id: 3,
      img: BlogImg3,
      date: "Jan 08 2025",
      title:
        "From Concept to Launch: Our Approach to Seamless Mobile App Development",
      content:
        "At CodeInfoWay, we understand that creating a mobile application is more than just coding. It’s about bringing a vision to life, solving real-world problems, and delivering exceptional user experiences. Our end-to-end development process ensures that every app we build is not only functional but also future-ready. Here’s a closer look at how we turn your ideas into impactful mobile applications.",
    },
    {
      id: 4,
      img: BlogImg4,
      date: "Jan 08 2025",
      title: "Top Trends in Mobile App Development and How We’re Staying Ahead",
      content:
        "The mobile app development landscape is evolving rapidly, driven by advancements in technology and changing user expectations. At CodeInfoWay, we stay ahead of the curve by embracing the latest trends and innovations to deliver cutting-edge solutions to our clients. Here are the top trends shaping the industry and how we’re leveraging them to create impactful mobile applications.",
    },
    {
      id: 4,
      img: BlogImg5,
      date: "Jan 08 2025",
      title:
        "Empowering Businesses with Custom Mobile Apps: Our Story and Vision",
      content:
        "At CodeInfoWay, we believe that technology has the power to transform businesses and create opportunities that were once unimaginable. Since our inception, we have been on a mission to empower companies by delivering custom mobile applications tailored to their unique needs. This is our story and the vision that drives us forward.",
    },
  ];

  const totalPages = Math.ceil(blogs.length / blogsPerPage);

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
  };

  const displayedBlogs = blogs.slice(
    (activePage - 1) * blogsPerPage,
    activePage * blogsPerPage
  );
  return (
    <>
      <div className="common-banner">
        <div className="container">
          <div className="banner-content">
            <h2>Blogs</h2>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Blogs
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <div className="blog-grid">
        <div className="container">
          <div className="row">
            {displayedBlogs.map((blog) => (
              <div className="col-lg-4" key={blog.id}>
                <div className="main-blog">
                  <Link to="/blog-detail">
                    <img src={blog.img} alt={`Blog ${blog.id}`} />
                    <div className="blog-content">
                      <span>{blog.date}</span>
                      <h3>{blog.title}</h3>
                      <p>{blog.content}</p>
                    </div>
                  </Link>
                </div>
              </div>
            ))}
          </div>

          <Pagination className="justify-content-center mt-4">
            <Pagination.Prev
              onClick={() => handlePageChange(Math.max(activePage - 1, 1))}
              disabled={activePage === 1}
            />
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <Pagination.Item
                key={page}
                active={page === activePage}
                onClick={() => handlePageChange(page)}
              >
                {page}
              </Pagination.Item>
            ))}
            <Pagination.Next
              onClick={() =>
                handlePageChange(Math.min(activePage + 1, totalPages))
              }
              disabled={activePage === totalPages}
            />
          </Pagination>
        </div>
      </div>
    </>
  );
};
